export const themes = {
    yellow: { bg: 'bg-[#FFDE59]', accent: 'bg-[#FFCC92]', text: 'text-black' },
    pink: { bg: 'bg-[#FF66C4]', accent: 'bg-[#CB6CE6]', text: 'text-black' },
    blue: { bg: 'bg-[#5CE1E6]', accent: 'bg-[#004AAD]', text: 'text-black' },
    green: { bg: 'bg-[#7ED957]', accent: 'bg-[#38B6FF]', text: 'text-black' },
    white: { bg: 'bg-white', accent: 'bg-gray-200', text: 'text-black' },

    // Tokyo Night Palette
    tokyoRed: { bg: 'bg-[#f7768e]', accent: 'bg-[#bb9af7]', text: 'text-black' },
    tokyoGreen: { bg: 'bg-[#9ece6a]', accent: 'bg-[#7aa2f7]', text: 'text-black' },
    tokyoYellow: { bg: 'bg-[#e0af68]', accent: 'bg-[#f7768e]', text: 'text-black' },
    tokyoBlue: { bg: 'bg-[#7aa2f7]', accent: 'bg-[#bb9af7]', text: 'text-black' },
    tokyoPurple: { bg: 'bg-[#bb9af7]', accent: 'bg-[#7aa2f7]', text: 'text-black' },
    tokyoCyan: { bg: 'bg-[#7dcfff]', accent: 'bg-[#7aa2f7]', text: 'text-black' },
    tokyoDark: { bg: 'bg-[#1a1b26]', accent: 'bg-[#c0caf5]', text: 'text-[#c0caf5]' },
};
